module.exports = __webpack_public_path__ + "media/scss/webfonts/384AEE_0_0-cad22e53e806adb0091d72e93217b791.ttf";